import Home from '@/views/pages/Home.vue'
import Index from '@/views/pages/index.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'home',
    component: Home,
    redirect:'/index', // 默认重定向到首页
    children: [
      {
        path: 'index',
        name: 'index',
        component: Index
      },
      {
        path: 'products',
        name: 'productList',
        component: () => import('@/views/pages/ProductList.vue')
      },
      {
        path: 'product/:id',
        name: 'productDetail',
        component: () => import('@/views/pages/ProductDetail.vue')
      },
      {
        path: 'presale',
        name: 'presaleList',
        component: () => import('@/views/pages/PresaleList.vue')
      },
      {
        path: 'presale/:id',
        name: 'presaleDetail',
        component: () => import('@/views/pages/PresaleDetail.vue')
      },
      {
        path: 'cart',
        name: 'cart',
        component: () => import('@/views/pages/Cart.vue')
      },
      {
        path: 'order/:orderId',
        name: 'orderDetail',
        component: () => import('@/views/pages/OrderDetail.vue')
      },
      {
        path: 'personal-space',
        name: 'personalSpace',
        component: () => import('@/views/pages/PersonalSpace.vue'),
        redirect: '/personal-space/orders',
        children: [
          {
            path: 'orders',
            name: 'myOrders',
            component: () => import('@/views/pages/personal/MyOrders.vue')
          },
          {
            path: 'payments',
            name: 'paymentRecords',
            component: () => import('@/views/pages/personal/PaymentRecords.vue')
          },
          {
            path: 'addresses',
            name: 'addressManager',
            component: () => import('@/views/pages/personal/AddressManager.vue')
          },
          {
            path: 'profile',
            name: 'userProfile',
            component: () => import('@/views/pages/personal/UserProfile.vue')
          }
        ]
      },
    ]
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/login.vue')
  },
  {
    path: '/order/list',
    redirect: '/personal-space/orders'
  }
]

const router = new VueRouter({
  routes,
  mode: 'hash'
})

export default router
